<template>
  <a-spin :spinning="pageLoading" tip="操作中...">
    <div>
      <!-- 顶部按钮和搜索 -->
      <div class="app-container">
      <div style="margin-bottom: 10px">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div>
            <vxe-button @click="addFun" status="primary">新增</vxe-button>
          </div>
          <div style="display: flex; align-items: center">
            <span style="margin-right: 8px">触达渠道编码:</span>
            <a-input
              v-model="queryCondition.channelCode"
              placeholder="触达渠道编码"
              style="width: 200px; margin-right: 1rem"
              allow-clear
            />
            <span style="margin-right: 8px">触达渠道:</span>
            <a-select
              v-model="queryCondition.channelName"
              placeholder="触达渠道名称"
              style="width: 200px; margin-right: 1rem"
              allow-clear
              show-search
              :filter-option="filterChannelOption"
            >
              <a-select-option
                v-for="channel in allChannels"
                :key="channel.id"
                :value="channel.channelName"
              >
                {{ channel.channelName }}
              </a-select-option>
            </a-select>
            <vxe-button status="primary" @click="queryByPage(1)">查询</vxe-button>
            <vxe-button class="filter-search-item" @click="resetForm">重置</vxe-button>
          </div>
        </div>
      </div>

      <!-- table列表 -->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
      >
        <vxe-column type="seq" title="序号" width="80" align="center" />
        <vxe-column field="channelCode" title="触达渠道编码" min-width="150" align="center" />
        <vxe-column field="channelName" title="触达渠道名称" min-width="150" align="center" />
        <vxe-column field="sourceNames" title="关联线索来源" min-width="250" align="center" />
        <vxe-column field="createDate" title="创建时间" min-width="180" align="center">
          <template #default="{ row }">
            {{ row.createDate | dateFormat('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </vxe-column>
        <vxe-column title="操作" width="200" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate">
              <a-button size="small" type="link" status="primary" @click="editFun(row)">编辑</a-button>
              <a-button size="small" type="link" status="primary" @click="deleteFun(row)">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>

    <!-- 新增/修改对话框 -->
    <a-modal
      :title="dialogTitle"
      v-model="dialogVisible"
      width="600px"
      @ok="submitForm"
      @cancel="cancelForm"
    >
      <a-form-model
        ref="channelForm"
        :model="formData"
        :rules="formRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="触达渠道编码" prop="channelCode">
          <a-input
            v-model="formData.channelCode"
            placeholder="请输入触达渠道编码"
            :maxLength="50"
            :disabled="!!formData.id"
          />
        </a-form-model-item>
        <a-form-model-item label="触达渠道名称" prop="channelName">
          <a-input
            v-model="formData.channelName"
            placeholder="请输入触达渠道名称"
            :maxLength="100"
          />
        </a-form-model-item>
        <a-form-model-item label="关联线索来源" prop="sourceIdList">
          <a-select
            v-model="formData.sourceIdList"
            mode="multiple"
            placeholder="请选择线索来源"
            style="width: 100%"
          >
            <a-select-option
              v-for="item in sourceOptions"
              :key="item.codeId"
              :value="item.codeId"
            >
              {{ item.codeName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            v-model="formData.remark"
            placeholder="请输入备注"
            :rows="4"
            :maxLength="500"
          />
        </a-form-model-item>
      </a-form-model>
      <span slot="footer" class="dialog-footer">
        <vxe-button size="small" @click="cancelForm">取 消</vxe-button>
        <vxe-button size="small" status="primary" @click="submitForm">确 定</vxe-button>
      </span>
    </a-modal>
    </div>
  </a-spin>
</template>

<script>
import { dataApi } from '@/services/comm/clueTouchChannel.js'
import { loadBaseCodeData } from '@/services/baseCodeSource'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  name: 'ClueTouchChannel',
  data() {
    return {
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      tableData: [],
      allChannels: [], // 所有渠道列表，用于下拉框
      allAlign: 'center',
      queryCondition: {
        channelCode: '',
        channelName: ''
      },
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {
        id: null,
        channelCode: '',
        channelName: '',
        sourceIdList: [],
        remark: ''
      },
      formRules: {
        channelCode: [
          { required: true, message: '请输入触达渠道编码', trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: '请输入触达渠道名称', trigger: 'blur' }
        ],
        sourceIdList: [
          { required: true, message: '请选择线索来源', trigger: 'change', type: 'array' }
        ]
      },
      sourceOptions: [], // 线索来源选项
      pageLoading: false // 页面全局loading状态（用于新增、编辑、删除操作）
    }
  },
  async created() {
    // 加载线索来源码表
    this.sourceOptions = await loadBaseCodeData('CD200004')
    console.log('线索来源选项:', this.sourceOptions)
    // 加载所有渠道（用于下拉框）
    this.loadAllChannels()
    this.queryByPage()
  },
  activated() {
    this.loadAllChannels()
    this.queryByPage()
  },
  methods: {
    // 加载所有渠道列表（用于下拉框）
    async loadAllChannels() {
      try {
        const res = await dataApi.queryPage({
          page: 1,
          limit: 9999, // 获取所有数据
          channelCode: null,
          channelName: null
        })
        if (res.code === 200 && res.data) {
          this.allChannels = res.data.records || res.data.list || []
        }
      } catch (error) {
        console.error('加载渠道列表失败:', error)
      }
    },
    // 下拉框搜索过滤
    filterChannelOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {
        channelCode: '',
        channelName: ''
      }
      this.queryByPage(1)
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      this.listLoading = true
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        channelCode: this.queryCondition.channelCode || null,
        channelName: this.queryCondition.channelName || null
      }
      console.log('查询参数:', queryData)
      dataApi.queryPage(queryData).then(res => {
        if (res.code === 200 && res.data) {
          // 处理线索来源名称显示
          this.tableData = res.data.records.map(item => {
            if (item.sourceIdList && item.sourceIdList.length > 0) {
              const sourceNames = item.sourceIdList.map(sourceId => {
                const source = this.sourceOptions.find(opt => opt.codeId === sourceId)
                return source ? source.codeName : sourceId
              })
              item.sourceNames = sourceNames.join('、')
            } else {
              item.sourceNames = ''
            }
            return item
          })
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('搜索失败')
          this.listLoading = false
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 新增
    addFun() {
      this.dialogTitle = '新增'
      this.formData = {
        id: null,
        channelCode: '',
        channelName: '',
        sourceIdList: [],
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.channelForm) {
          this.$refs.channelForm.clearValidate()
        }
      })
    },
    // 修改
    editFun(row) {
      this.dialogTitle = '修改'
      dataApi.getById(row.id).then(res => {
        if (res.code === 200) {
          this.formData = {
            id: res.data.id,
            channelCode: res.data.channelCode,
            channelName: res.data.channelName,
            sourceIdList: res.data.sourceIdList || [],
            remark: res.data.remark || ''
          }
          this.dialogVisible = true
          this.$nextTick(() => {
            if (this.$refs.channelForm) {
              this.$refs.channelForm.clearValidate()
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 删除
    deleteFun(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除该触达渠道？',
        onOk: () => {
          this.pageLoading = true
          dataApi.delete(row.id).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              // 刷新渠道列表
              this.loadAllChannels()
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log(err)
            this.$message.error('删除失败')
          }).finally(() => {
            this.pageLoading = false
          })
        },
        onCancel() {}
      })
    },
    // 提交表单
    submitForm() {
      this.$refs.channelForm.validate(valid => {
        if (valid) {
          if (this.pageLoading) return // 防止重复提交
          this.pageLoading = true
          const apiMethod = this.formData.id ? dataApi.update : dataApi.add
          apiMethod(this.formData).then(res => {
            if (res.code === 200) {
              this.$message.success(this.formData.id ? '修改成功' : '新增成功')
              this.dialogVisible = false
              // 刷新渠道列表
              this.loadAllChannels()
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log(err)
            this.$message.error('操作失败')
          }).finally(() => {
            this.pageLoading = false
          })
        }
      })
    },
    // 取消表单
    cancelForm() {
      this.dialogVisible = false
      this.pageLoading = false
      this.$refs.channelForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.a-input--medium .a-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.a-button {
  font-size: 12px;
}

/* 全屏loading样式 */
::v-deep .ant-spin-container {
  min-height: calc(100vh - 200px);
}

::v-deep .ant-spin-nested-loading > div > .ant-spin {
  max-height: none;
}
</style>
